export default {
      id: "calf-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#calf",
      toString: function () {
        return this.url;
      }
    }